var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"side-left-container"},[_c('private-top',{staticClass:"top"}),_c('private-middle',{staticClass:"middle"}),_c('private-bottom',{staticClass:"bottom"}),_c('private-end',{staticClass:"end"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }